import React from 'react';
import usePrintFile from 'modules/FileManagerV2/hooks/ui/usePrintFile';
import GlobalTooltip from 'components/GlobalTooltip';

function PrintFile(props) {
  const { rowData, isFromFilePreviewModal, filePreviewModalIconClassName, imageRef } = props;

  const { pdfTronPrintFile } = usePrintFile();

  const printFile = (rowData) => {
    pdfTronPrintFile(rowData);
  };

  const iconClassName =
    isFromFilePreviewModal && filePreviewModalIconClassName ? filePreviewModalIconClassName : 'icon-Print text-primary-main';

  return (
    <>
      <span role="button" onClick={() => printFile(rowData)}>
        <GlobalTooltip tooltip="Print" className="text-primary-main" position="top">
          <i className={iconClassName} aria-hidden="true" />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default PrintFile;
